export const name = "profile";
export const version = "1.0.0";
export const description = "a personal website";
export const keywords = [];
export const license = "";
export const author = "lawvs";